// Iconos del portal: SVG inline, trazo 2px, terminaciones redondeadas, un
// path por glifo, viewBox 24x24, `currentColor` (readme de identidad,
// seccion Iconography). Identidad no tiene libreria de iconos y admite Lucide
// como sustitucion con este mismo trazo; estos glifos siguen esa regla y
// quedan propuestos para assets/icons/ (docs/PLAN-REDISENO-PORTAL.md §8).
// Nunca un emoji; nunca un PNG.
import { cn } from "./cn.js";

const PATHS = {
  inicio: "M3 11.5 12 4l9 7.5V20a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z",
  viajes: "M4 16V9.5A3.5 3.5 0 0 1 7.5 6h9A3.5 3.5 0 0 1 20 9.5V16M4 16h16M4 16v2h2.5M20 16v2h-2.5M7 18a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0zm7 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0zM4 12h16",
  mapa: "M12 21s-6-5.33-6-10a6 6 0 0 1 12 0c0 4.67-6 10-6 10zm0-7.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z",
  nomina: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm13 10v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75",
  vencimientos: "M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm7 10v3m0-6v.5",
  exportable: "M12 3v12m0 0 4-4m-4 4-4-4M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2",
  liquidacion: "M6 3h9l4 4v14H6zM15 3v4h4M9 12h6M9 16h6M12 10v8",
  menu: "M4 7h16M4 12h16M4 17h16",
  cerrar: "M18 6 6 18M6 6l12 12",
  plegar: "M15 6l-6 6 6 6",
  desplegar: "M9 6l6 6-6 6",
  cuenta: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
  bandeja: "M4 4h16v12H4zM4 16l2 4h12l2-4M9 9h6",
  sinConexion: "M7 18a4 4 0 0 1-.6-7.95A6 6 0 0 1 18 8a4.5 4.5 0 0 1 0 9H7zM3 3l18 18",
  tilde: "m5 12 4.5 4.5L19 7",
  imprimir: "M6 9V3h12v6M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2M6 14h12v7H6z",
  copiar: "M9 9h10v12H9zM5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1",
  compartir: "M4 12v7a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7M16 6l-4-4-4 4m4-4v13",
  actualizar: "M21 12a9 9 0 1 1-2.64-6.36M21 3v6h-6",
  alerta: "M12 9v4m0 4h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z",
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, className, ...props }: { name: IconName } & React.SVGAttributes<SVGSVGElement>): React.JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className={cn("size-4 shrink-0", className)}
      {...props}
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
